import { Button, Flex, Form, Input } from "antd";
import { useEffect } from "react";
import CustomDrawer from "../../../../../components/ui/CustomDrawer";
import {
  useCreateSalarySlabMutation,
  useUpdateSalarySlabMutation,
} from "../../../../../features/organization/contractual/SalarySlab/salarySlabApi";
import useError from "../../../../../hooks/useError";
import { toast } from "../../../../../lib/toast";
import { validatePositiveNumber } from "../../../../../utils/validators";

const MangeSlab = ({
  data,
  type,
  open,
  handleClose,
}: {
  data?: any;
  type?: string;
  open: boolean;
  handleClose: (value?: boolean) => void;
}) => {
  const [form] = Form.useForm();

  const [
    createSlab,
    {
      isLoading: creating,
      isSuccess: created,
      isError: isCreateError,
      error: createError,
    },
  ] = useCreateSalarySlabMutation();
  const [
    updateSlab,
    {
      isLoading: updating,
      isSuccess: updated,
      isError: isUpdateError,
      error: updateError,
    },
  ] = useUpdateSalarySlabMutation();

  const handleSubmit = (values: any) => {
    if (type === "ADD") {
      createSlab(values);
    } else {
      updateSlab({ data: values, id: data?.id });
    }
  };

  // ------ Effects ------
  useEffect(() => {
    if (data) {
      form.setFieldsValue(data);
    }
  }, [data, form]);

  useEffect(() => {
    if (created) {
      toast("success", "Salary slab created successfully.");
      handleClose();
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [created]);

  useEffect(() => {
    if (updated) {
      toast("success", "Salary slab updated successfully.");
      handleClose();
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updated]);

  // ------ Errors ------
  useError(isCreateError, createError, "Salary slab create failed.");
  useError(isUpdateError, updateError, "Salary slab update failed.");
  return (
    <CustomDrawer
      width={460}
      open={open}
      onClose={() => {
        handleClose();
        form.resetFields();
      }}
      title={type === "ADD" ? "Add New Salary Slab" : "Edit Salary Slab"}
    >
      <Form
        form={form}
        size="large"
        layout="vertical"
        requiredMark="optional"
        className="custom-form"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="slab_name"
          label="Slab name"
          className="mb-4"
          rules={[{ required: true, message: "Please enter slab name" }]}
        >
          <Input placeholder="Enter slab name" />
        </Form.Item>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Form.Item
            name="fixed_amount"
            label="Fixed Amount"
            className="mb-4"
            rules={[
              { required: true, message: "Please enter fixed amount" },
              { validator: validatePositiveNumber },
            ]}
          >
            <Input suffix="BDT" placeholder="0.00" />
          </Form.Item>
          <Form.Item
            name="variable_amount"
            label="Variable Amount"
            className="mb-4"
            rules={[
              { required: true, message: "Please enter variable amount" },
              { validator: validatePositiveNumber },
            ]}
          >
            <Input suffix="BDT" placeholder="0.00" />
          </Form.Item>
        </div>
        <Flex align="center" gap={16} className="mt-6">
          <Button
            size="middle"
            htmlType="button"
            className="min-w-[120px] h-10"
            onClick={() => handleClose()}
          >
            Cancel
          </Button>
          <Button
            size="middle"
            htmlType="submit"
            type="primary"
            color="primary"
            loading={creating || updating}
            className="min-w-[120px] h-10"
          >
            {type === "ADD" ? "Create" : "Update"}
          </Button>
        </Flex>
      </Form>
    </CustomDrawer>
  );
};

export default MangeSlab;
